import { Link } from "react-router-dom";
import type { Special } from "@/mocks/specials";

interface SpecialCardProps {
  special: Special;
  compact?: boolean;
}

export default function SpecialCard({
  special,
  compact = false,
}: SpecialCardProps) {
  return (
    <Link
      to={`/special?sid=${special.id}`}
      className="group relative block overflow-hidden rounded-lg"
    >
      <div
        className={`relative w-full ${compact ? "aspect-[16/9]" : "aspect-[16/10]"}`}
      >
        <img
          src={special.cover}
          alt={`${special.title} 专题主图`}
          title={`${special.title} 百合影视专题`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 p-5">
          <span className="inline-flex items-center gap-1 rounded-full bg-accent-500/90 px-2.5 py-0.5 text-[11px] font-medium text-background-50">
            <i className="ri-bookmark-3-line" />
            专题合集
          </span>
          <h3 className="mt-2.5 font-heading text-base font-bold leading-snug text-white md:text-lg">
            {special.title}
          </h3>
          <p className="mt-1.5 hidden text-xs text-white/80 line-clamp-1 sm:block">
            {special.subtitle}
          </p>
          <span className="mt-3 inline-flex items-center gap-1 text-xs text-white/90 transition-transform duration-300 group-hover:translate-x-1">
            查看合集
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </span>
        </div>
      </div>
    </Link>
  );
}